import { Appointment, Claim, Dossier } from '@sc/data-access-models';

export class SetDossierAction {
  static readonly type = '[Dossier] Set';

  constructor(public dossier: Partial<Dossier>) {}
}

export class PatchDossierAction {
  static readonly type = '[Dossier] Patch';

  constructor(public payload: Partial<Dossier>) {}
}

export class ClearDossierAction {
  static readonly type = '[Dossier] Clear';
}

export class PatchClaimAction {
  static readonly type = '[Dossier] Patch claim';

  constructor(public payload: Partial<Claim>) {}
}

export class PatchAppointmentAction {
  static readonly type = '[Dossier] Patch appointment';

  constructor(public payload: Partial<Appointment>) {}
}
